import React, { Component, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";
import fadeInOut from "../../vendors/fadeInOut";
import AA_GLOBAL from "../../globals/globals";

// COMPONENTS
import CheckLoader from "../loaders/CheckLoader";

let ModalData = {
  slideDown: { top: "50%" },
  toggleButtonFocusState: 0,
  savePrevSelectedEl: null,
};

const ModalOld = ( props, intl ) => {
  const rerender = useSelector(state => state.app.rerenderModal);
  let modal = null;

  useEffect(() => {
    modal = document.getElementById(`modal_con`);
    if (modal) modal.focus();
  }, [props, rerender]);

  const handleTabPress = e => {
    let keyCode = e.which || e.keyCode;

    if (keyCode === 9) {
      e.preventDefault();

      const selectabeEl = document.querySelectorAll(".id-selectableEl");
      selectabeEl[ModalData.toggleButtonFocusState].focus();

      if (ModalData.toggleButtonFocusState === 0) {
        ModalData.toggleButtonFocusState = 1;
      } else if (ModalData.toggleButtonFocusState === 1) {
        ModalData.toggleButtonFocusState = 0;
      }
    }
  };

  const loaderDone = () => {
    props.loaderDone();
  };

  const hideModal = e => {
    if (e.target.getAttribute("data-modal")) {
      hide();
    }
  };

  const handleKeyDown = e => {
    if (e.key === "Escape") {
      hide();
    }
  };

  const hide = () => {
    // focus last el focused before the modal
    if (
      AA_GLOBAL.clickedElBeforeModalID &&
      document.getElementById(AA_GLOBAL.clickedElBeforeModalID)
    ) {
      document.getElementById(AA_GLOBAL.clickedElBeforeModalID).focus();
      AA_GLOBAL.clickedElBeforeModalID = null;
      modal = null;
    }

    if (props.no) {
      props.no();
    }
    const el = document.getElementById(props.id);
    fadeInOut(el, "500", false);
  };

  const renderPrompt = () => {
    return (
      <div
        data-test="propmptModal"
        tabIndex="0"
        style={{ outline: "none" }}
        id={`modal_con`}
        onKeyDown={handleTabPress}
      >
        <div className="modal__msg" id={`modal_msg_${props.id}`} data-test="propmptModal_msg">
          {props.intl ? <FormattedMessage id={props.msg} /> : props.msg}
        </div>

        <div className="modal__btnCon">
          <button
            tabIndex="0"
            aria-label={props.intl.formatMessage({ id: "confirm" })}
            data-test="propmptModal_confirmBtn"
            className="button button__main-form id-selectableEl"
            id={`yes${props.id}`}
            onClick={props.yes}
          >
            {props.intl ? <FormattedMessage id={props.yesMsg} /> : props.yesMsg}
          </button>
          <button
            tabIndex="0"
            aria-label={props.intl.formatMessage({ id: "cancle" })}
            data-test="propmptModal_cancelBtn"
            className="button button__main-form id-selectableEl"
            id={`no${props.id}`}
            onClick={hide}
          >
            {props.intl ? <FormattedMessage id={props.noMsg} /> : props.noMsg}
          </button>
        </div>
      </div>
    );
  };

  const sppiner = done => {
    return <CheckLoader done={done} loaderDone={loaderDone} />;
  };

  return (
    <div
      id={props.id}
      ref={props.myRef}
      data-modal={props.id}
      className="modal__Modalback modal--defaultCol"
      onClick={hideModal}
      onKeyDown={handleKeyDown}
      data-test="modalBack"
    >
      <div
        className="modal"
        role="dialog"
        aria-labelledby={`modal_msg_${props.id}`}
        style={props.visibility ? ModalData.slideDown : ModalData.slideDown}
        data-test="modal"
      >
        <div style={{ marginBottom: "1rem" }}>
          {props.loader ? sppiner(props.loader) : sppiner(props.loader)}
        </div>
        {props.loader === undefined ? renderPrompt() : null}
      </div>
    </div>
  );
};

// ModalOld.propTypes = {
//   visibility: PropTypes.bool,
//   loader: PropTypes.bool,
//   intl: PropTypes.bool,
//   yes: PropTypes.func,
//   yesMsg: PropTypes.string,
//   no: PropTypes.func,
//   noMsg: PropTypes.string,
//   msg: PropTypes.string,
//   promptModal: PropTypes.bool, // defines what do you whant to see in modal
// };

export default injectIntl(ModalOld);
